webpackJsonp([35783957827783],{

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/grillbar.e3419169.jpg";

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/latteexpress.1e1a315b.jpg";

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shenkee.360df9b2.jpg";

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shenkee = __webpack_require__(280);
	
	var _shenkee2 = _interopRequireDefault(_shenkee);
	
	var _latteexpress = __webpack_require__(279);
	
	var _latteexpress2 = _interopRequireDefault(_latteexpress);
	
	var _grillbar = __webpack_require__(278);
	
	var _grillbar2 = _interopRequireDefault(_grillbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "p",
	      { className: "redoutline" },
	      "We manufacture custom\xA0made signs\xA0and\xA0awnings from the San\xA0Francisco\xA0Bay\xA0Area."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement("img", {
	        className: "feature",
	        src: _shenkee2.default,
	        style: { height: 321, width: 432 }
	      })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement("img", { className: "feature", src: _latteexpress2.default })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement("img", { className: "feature", src: _grillbar2.default })
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8d4a7af480021b6ab935.js